/**
 * Rutas del modo Técnica: la única fuente de los paths del módulo.
 *
 * No hay un TecnicaRoutesContext como el de Sueldos: Sueldos lo necesita porque las mismas
 * pantallas viven bajo dos prefijos (/sueldos y /portal-sueldos). Técnica tiene un solo prefijo,
 * así que alcanza con constantes. Las rutas viejas (/admin/tecnica/orden/:id,
 * /admin/configuracion/tecnica, …) siguen existiendo sólo como redirecciones (TecnicaRoutes.jsx),
 * porque puede haber links viejos en mails, WhatsApp o favoritos.
 */
export const TECNICA_BASE = "/admin/tecnica";

export const TECNICA_RUTAS = {
    inicio: TECNICA_BASE,
    clientes: `${TECNICA_BASE}/clientes`,
    clientesBajas: `${TECNICA_BASE}/clientes/bajas`,
    cliente: (id, solapa) => `${TECNICA_BASE}/clientes/${id}${solapa ? `?tab=${solapa}` : ""}`,
    ordenes: `${TECNICA_BASE}/ordenes`,
    nuevaOrden: `${TECNICA_BASE}/ordenes/nueva`,
    // Nueva orden con el cliente (y la cuenta) ya elegidos; con solicitudId, la que sale de esa solicitud aprobada.
    nuevaOrdenPara: ({ clienteId, cuentaId, solicitudId } = {}) => {
        const query = new URLSearchParams();
        if (clienteId) query.set("cliente", clienteId);
        if (cuentaId) query.set("cuenta", cuentaId);
        if (solicitudId) query.set("solicitud", solicitudId);
        const texto = query.toString();
        return `${TECNICA_BASE}/ordenes/nueva${texto ? `?${texto}` : ""}`;
    },
    solicitudes: `${TECNICA_BASE}/solicitudes`,
    // Recorridos: el día de todos los técnicos, y el de uno. La fecha (yyyy-mm-dd) va en la query para que el link se
    // pueda compartir y sobreviva a una recarga; sin ella se abre hoy.
    recorridos: (fecha) => `${TECNICA_BASE}/ordenes/recorridos${fecha ? `?fecha=${fecha}` : ""}`,
    recorrido: (tecnicoId, fecha) => `${TECNICA_BASE}/ordenes/recorridos/${tecnicoId}${fecha ? `?fecha=${fecha}` : ""}`,
    orden: (id) => `${TECNICA_BASE}/ordenes/${id}`,
    editarOrden: (id) => `${TECNICA_BASE}/ordenes/${id}/editar`,
    estadisticas: `${TECNICA_BASE}/estadisticas`,
    configuracion: (solapa = "notificaciones") => `${TECNICA_BASE}/configuracion/${solapa}`,
    stock: (solapa = "saldos") => `${TECNICA_BASE}/stock/${solapa}`,
    articulo: (id) => `${TECNICA_BASE}/stock/articulo/${id}`,
    tecnicoStock: (employeeId) => `${TECNICA_BASE}/stock/tecnicos/${employeeId}`,
    miStock: `${TECNICA_BASE}/mi-stock`,
    // Incidentes no es una solapa de Stock: tiene ruta propia (y la ficha, la suya, para compartir el link).
    incidentes: `${TECNICA_BASE}/incidentes`,
    incidente: (id) => `${TECNICA_BASE}/incidentes/${id}`,
    // Diferencias (tanda 8): los insumos que un técnico cargó sin tenerlos en su stock. Sólo Gestión.
    diferencias: `${TECNICA_BASE}/diferencias`,
};

/** true en /admin/tecnica y debajo; no en /admin/tecnicaX. El Layout la usa para cambiar de menú. */
export const esRutaTecnica = (pathname = "") =>
    pathname === TECNICA_BASE || pathname.startsWith(`${TECNICA_BASE}/`);

/** Las solapas de stock, en el orden del menú. Cada una es un ítem propio (tecnicaMenu.js). */
export const SOLAPAS_STOCK = ["saldos", "remitos", "movimientos", "catalogo", "herramientas", "kits", "tecnicos"];

/** Las subsecciones de Configuración: siguen siendo solapas dentro de un solo ítem del menú. */
export const SOLAPAS_CONFIGURACION = ["notificaciones", "autorizaciones", "permisos-stock"];
